import { globalLoggerToken } from "@/tokens";
import ApiClient from "@lib/ApiClient";
import { SDK_MODULES } from "@modules/sdk/constants";
import { SdkModule } from "@modules/sdk/SdkModule";
import { container, instanceCachingFactory, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import { apiClientToken } from "./di_tokens";
import ShopifyDiscountQuery from "./query/ShopifyDiscountQuery";
import { DiscountService } from "./service/DiscountService";
import { DiscountServiceShopifyApiStrategy } from "./service/DiscountServiceShopifyApiStrategy";
import ShopifyDiscountStore from "./store/ShopifyDiscountStore";

interface ShopifyDiscountModuleExports {
    shopifyDiscountApiService: DiscountService;
    shopifyDiscountStore: ShopifyDiscountStore;
    shopifyDiscountQuery: ShopifyDiscountQuery;
}

@singleton()
export class ShopifyDiscountModule
    implements ModuleInterface<ShopifyDiscountModuleExports>
{
    exports: ShopifyDiscountModuleExports;

    public constructor() {
        const logger = container
            .resolve(globalLoggerToken)
            .newLogger("ShopifyDiscountModule");

        container.register(apiClientToken, {
            useFactory: instanceCachingFactory(() => {
                return new ApiClient();
            }),
        });

        const discountService = new DiscountService(
            container.resolve(ShopifyDiscountStore),
            new DiscountServiceShopifyApiStrategy(
                container.resolve(apiClientToken)
            ),
            logger
        );

        // Prepare SDK module for dynamic import
        void (async () => {
            const { sdkDynamicModulesManager, sdk } =
                container.resolve(SdkModule).exports;

            const DiscountsSdk = await sdkDynamicModulesManager.import(
                SDK_MODULES.DISCOUNTS
            );
            const discountsSdk = new DiscountsSdk(discountService);
            sdk.registerModule(SDK_MODULES.DISCOUNTS, discountsSdk);
        })();

        this.exports = {
            shopifyDiscountApiService: discountService,
            shopifyDiscountStore: container.resolve(ShopifyDiscountStore),
            shopifyDiscountQuery: container.resolve(ShopifyDiscountQuery),
        };
    }

    public registerProviders() {
        return {};
    }
}
